module.exports = __webpack_public_path__ + "static/Sahel-Bold-c60ddc8b486fe1f0d1856847efbcd451.ttf";